///////////////////////////////////////////////////////////////////////////////
//版权所有（C）2002-2022，成都梦想凯德科技有限公司。
//本软件及其文档和相关资料归成都梦想凯德科技有限公司
//应用包含本软件的程序必须包括以下声明
//在版权声明中：
//此应用程序与成都梦想凯德科技有限公司成协议。
//通过使用本软件、其文档或相关材料
///////////////////////////////////////////////////////////////////////////////
import * as THREE from "three";
import { McEdGetPointWorldDrawObject, McGiWorldDraw, MrxDbgUiPrPoint, MxDbLine, MxDbRect, MxFilters, MxFun } from "mxdraw";
export async function Mx_DrawRect() {
    const getPoint = new MrxDbgUiPrPoint();
    getPoint.setMessage("\n指定第一点:");
    let pt1: THREE.Vector3 | null = await getPoint.go();
    if (!pt1) {
        return;
    }

    let rect = new MxDbRect();
    rect.pt1 = pt1;
    // 在点取第二点时，设置动态绘制.
    const worldDrawComment = new McEdGetPointWorldDrawObject();
    worldDrawComment.setDraw((currentPoint: THREE.Vector3) => {
        rect.pt2 = currentPoint;
        worldDrawComment.drawCustomEntity(rect);
    });

    getPoint.setBasePt(pt1);
    getPoint.setUseBasePt(true);

    getPoint.setUserDraw(worldDrawComment);
    getPoint.setMessage("\n指定第二点:");

    let pt2: THREE.Vector3 | null = await getPoint.go();
    if (!pt2) {
        return;
    }

    rect.pt2 = getPoint.value();
    rect.color = new THREE.Color("#665533");
    rect.opacity = 0.9;
    rect.renderOrder = 5;
    rect.isSolidColorFill = true;
    rect.setRadius(10);
    MxFun.getCurrentDraw().addMxEntity(rect);

    // 虚线长度
    let lenDash = MxFun.screenCoordLong2Doc(10);

    {
        let line = new MxDbLine();
        line.pt1 = new THREE.Vector3(pt1.x, pt1.y, 0);
        line.pt2 = new THREE.Vector3(pt1.x, pt2.y, 0);


        line.setDashLen(lenDash);
        line.setLineWidth(10);
        line.setLineWidthByPixels(true);
        line.setDashLineDisplay(true);
        MxFun.addToCurrentSpace(line);
    }

    {
        let line = new MxDbLine();
        line.pt1 = new THREE.Vector3(pt1.x, pt2.y, 0);
        line.pt2 = new THREE.Vector3(pt2.x, pt2.y, 0);


        line.setDashLen(lenDash);
        line.setLineWidth(10);
        line.setLineWidthByPixels(true);
        line.setDashLineDisplay(true);
        MxFun.addToCurrentSpace(line);
    }

    {
        let line = new MxDbLine();
        line.pt1 = new THREE.Vector3(pt2.x, pt2.y, 0);
        line.pt2 = new THREE.Vector3(pt2.x, pt1.y, 0);


        line.setDashLen(lenDash);
        line.setLineWidth(10);
        line.setLineWidthByPixels(true);
        line.setDashLineDisplay(true);
        MxFun.addToCurrentSpace(line);
    }

    {
        let line = new MxDbLine();
        line.pt1 = new THREE.Vector3(pt2.x, pt1.y, 0);
        line.pt2 = new THREE.Vector3(pt1.x, pt1.y, 0);


        line.setDashLen(lenDash);
        line.setLineWidth(10);
        line.setLineWidthByPixels(true);
        line.setDashLineDisplay(true);
        MxFun.addToCurrentSpace(line);
    }
}


export class MyRect extends MxDbRect {
    public ang: number = 0;
    getGripPoints(): THREE.Vector3[] {
        let ret = new THREE.Vector3();
        ret.x = this.pt1.x + (this.pt2.x - this.pt1.x) * 0.5;
        ret.y = this.pt1.y + (this.pt2.y - this.pt1.y) * 0.5;
        return [ret];
    }

    moveGripPointsAt(index: number, offset: THREE.Vector3): boolean {
        if (index === 0) {
            this.pt1.add(offset);
            this.pt2.add(offset);
        }
        return true
    }

    public create(): MyRect {
        return new MyRect();
    }

    public getTypeName(): string {
        return "MyRect";
    }

    worldDraw(pWorldDraw: McGiWorldDraw): void {
        //super.worldDraw(pWorldDraw);
        let cen = new THREE.Vector3(this.pt1.x + (this.pt2.x - this.pt1.x) * 0.5, this.pt1.y + (this.pt2.y - this.pt1.y) * 0.5);

        let mat = new THREE.Matrix4().makeTranslation(cen.x, cen.y, 0).multiply(new THREE.Matrix4().makeRotationZ(this.ang)).multiply(new THREE.Matrix4().makeTranslation(-cen.x, -cen.y, 0));

        let pt1 = new THREE.Vector3(this.pt1.x, this.pt1.y, 0);
        let pt2 = new THREE.Vector3(this.pt1.x, this.pt2.y, 0);
        let pt3 = new THREE.Vector3(this.pt2.x, this.pt2.y, 0);
        let pt4 = new THREE.Vector3(this.pt2.x, this.pt1.y, 0);

        pt1.applyMatrix4(mat);
        pt2.applyMatrix4(mat);
        pt3.applyMatrix4(mat);
        pt4.applyMatrix4(mat);

        pWorldDraw.drawLine(pt1, pt2);
        pWorldDraw.drawLine(pt2, pt3);

        pWorldDraw.drawLine(pt3, pt4);
        pWorldDraw.drawLine(pt4, pt1);
    }

    dwgIn(obj: any): boolean {
        super.dwgIn(obj);

        this.ang = obj.ang;

        return true
    }

    dwgOut(obj: any): object {
        super.dwgOut(obj);
        obj.ang = this.ang;
        return obj
    }
}


export async function Mx_MyDrawRect() {
    const getPoint = new MrxDbgUiPrPoint();
    getPoint.setMessage("\n指定第一点:");
    let pt1: THREE.Vector3 | null = await getPoint.go();
    if (!pt1) {
        return;
    }

    let rect = new MyRect();
    rect.pt1 = pt1;
    rect.ang = Math.PI * 0.24;

    // 在点取第二点时，设置动态绘制.
    const worldDrawComment = new McEdGetPointWorldDrawObject();
    worldDrawComment.setDraw((currentPoint: THREE.Vector3) => {
        rect.pt2 = currentPoint;
        worldDrawComment.drawCustomEntity(rect);
    });

    getPoint.setBasePt(pt1);
    getPoint.setUseBasePt(true);

    getPoint.setUserDraw(worldDrawComment);
    getPoint.setMessage("\n指定第二点:");

    let pt2: THREE.Vector3 | null = await getPoint.go();
    if (!pt2) {
        return;
    }

    rect.pt2 = getPoint.value();
    rect.color = new THREE.Color("#FF2233");
    rect.opacity = 1;
    rect.renderOrder = 5;
    //rect.isSolidColorFill = true;
    rect.dLineWidth = MxFun.screenCoordLong2Doc(5);
    rect.lineWidthByPixels = false;

    //rect.setRadius(0);
    //rect.setFillImagePath("./models/img/mxcad.jpg");
    //rect.setFilter(new MxFilters().channel({r:33,g:0,b:0}));
    MxFun.getCurrentDraw().addMxEntity(rect);
}